import { Text } from "@dropbox/dig-components/typography";
import { Trans } from "@mirage/translations";
import { useState } from "react";
import styles from "./ConnectorsDescription.module.css";

import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Close_DashPrivacyModal } from "@mirage/analytics/events/types/close_dash_privacy_modal";
import { PrivacyModal } from "../flows/PrivacyModal";

export const ConnectorsDescription = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const { reportPapEvent } = useMirageAnalyticsContext();

  const privacyModalClosed = () => {
    setShowPrivacyModal(false);
    reportPapEvent(
      PAP_Close_DashPrivacyModal({
        featureLine: "onboarding",
      }),
    );
  };

  return (
    <>
      <Trans
        i18nKey={"self_serve_connectors_description"}
        components={{
          policyLink: (
            <Text
              data-testid="privacy-policy-link"
              className={styles.privacyLink}
              onClick={() => setShowPrivacyModal(true)}
            />
          ),
        }}
      />
      {showPrivacyModal && <PrivacyModal onClose={privacyModalClosed} />}
    </>
  );
};
